import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Document, DocumentListItemComponent} from "../document-list-item";
import {PdfPreviewComponent} from "../pdf-preview/pdf-preview.component";
import {DocumentItemEvent, DocumentItemEventType} from "../document-list-item/document-list-item.component";
import {DocumentRpcService} from "@alpha/services";
import {Helpers} from "../helpers";

@Component({
  selector: 'documents',
  standalone: true,
  imports: [CommonModule, DocumentListItemComponent, PdfPreviewComponent],
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent{

  constructor(private ds: DocumentRpcService) {
  }

  @Input() bid: string | undefined;
  @Input() documents: Document[] = [];
  @Input() current: Document | undefined;
  @Output() change: EventEmitter<DocumentComponentEvent> = new EventEmitter<DocumentComponentEvent>();

  @ViewChild(PdfPreviewComponent) pdfPreview : PdfPreviewComponent | undefined;

  previewStream: Uint8Array | undefined;

  selected: string[] = [];


  async onChange(evt: DocumentItemEvent) {
    switch (evt.type) {
      case DocumentItemEventType.Toggled:
        this.current = structuredClone(evt.document);
        await this.preview([this.current?.did])
        break;
      case DocumentItemEventType.Selected:
        const documentId = evt.document.did;
        this.selected.includes(documentId)
          ? (this.selected = this.selected.filter(s => s !== documentId))
          : this.selected.push(documentId);
        break;
    }
  }

  toggleSelection(){
    if(this.selected.length > 0){
      this.selected = [];
    }else{
       this.selected = this.documents.map(d=>d.did);
    }
  }
  async download() {
    try {
      const documents = (this.selected.length > 0) ? this.selected : [this.current!.did];
      const download = await this.ds.getDocumentDownload(this.bid ?? "", documents);
      if (download) {
        const ext =
          (documents.length > 1) ?
            'zip' :
            this.documents.find(d => d.did == documents[0])!.ext;
        Helpers.downloadData(download, new Date().toISOString() + '.' + ext, ext);
      }
    } catch (e) {
      console.error(e)
    }
  }

  async preview(documents: string[] = []) {
    try {
      this.previewStream = await this.ds.generatePreview(documents, this.bid ?? "");
      if(this.previewStream){
        await this.pdfPreview?.load(this.previewStream);
      }
    } catch (e) {
      console.error(e)
    }
  }
}

export interface DocumentComponentEvent {
  current: Document;
}
